.card {
  /* stylelint-disable-next-line declaration-property-value-allowed-list */
  padding-right: 1px; /* NOTE(sarah): Slightly hacky solution for chrome bug where the the edge of cards are very obviously cut off */
  scroll-snap-align: start;
  width: var(--carousel-card-width-mobile);

  @media (--reefer-media-tablet-min) {
    scroll-snap-align: var(--carousel-card-scroll-snap-align, start);
    width: var(--carousel-card-width);
  }
}
